import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { store } from '@/store/store';
import { hubClient } from '@tfpl/api-client';
import { getConfig } from '@/config';

@Module({ name: 'EnumsModule', store, dynamic: true, namespaced: true })
export class EnumsModule extends VuexModule {
  /**************************************************************************
   * STATE
   *************************************************************************/
  private _loading = false;
  private _error = false;
  private _officeAbsenceTypes: string[] = [];
  private _officeAbsenceStates: string[] = [];
  private _gameLeagues: string[] = [];

  /**************************************************************************
   * GETTERS
   *************************************************************************/
  get officeAbsenceTypes(): string[] {
    return this._officeAbsenceTypes;
  }

  get officeAbsenceStates(): string[] {
    return this._officeAbsenceStates;
  }

  get gameLeagues(): string[] {
    return this._gameLeagues;
  }

  get loading(): boolean {
    return this._loading;
  }

  get error(): boolean {
    return this._error;
  }

  /**************************************************************************
   * MUTATIONS
   *************************************************************************/
  @Mutation
  clearEnums(): void {
    this._officeAbsenceTypes = [];
    this._officeAbsenceStates = [];
  }

  @Mutation
  setEnums({
    officeAbsenceTypes,
    officeAbsenceStates,
    gameLeagues,
  }: Omit<hubClient.EnumsDto, 'bonusXpDonorTypes'>): void {
    this._officeAbsenceTypes = officeAbsenceTypes;
    this._officeAbsenceStates = officeAbsenceStates;
    this._gameLeagues = gameLeagues;
  }

  @Mutation
  setLoading(loading: boolean): void {
    this._loading = loading;
  }

  @Mutation
  setError(error: boolean): void {
    this._error = error;
  }

  /**************************************************************************
   * ACTIONS
   *************************************************************************/
  @Action({ rawError: true })
  public async fetchEnums(): Promise<void> {
    this.setLoading(true);
    try {
      const { data: response } = await hubClient.V2EnumsService.getMany({
        path: { tenant: getConfig().TENANT },
        throwOnError: true,
      });
      this.setEnums(response.data);
    } catch (err) {
      this.setError(true);
      console.error(err);
    } finally {
      this.setLoading(false);
    }
  }
}
export default getModule(EnumsModule);
